import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { connect } from "formik";
import { compose } from "redux";
import _ from "lodash";
import { AutoCompleteInput, DecimalInput } from "components/Global/FormikMaterial";
import { FIXED_RATE } from "components/Calculators/Constants/InterestRateType";

import {
  CAP_VOLS,
  MARKET_EXPECTATIONS_SHOCK,
  PARALLEL_SHOCK,
  STANDARD_DEVIATION_SHOCK
} from "../Constants/Constants";
import { shocks } from "../Constants/DropDownLists";

import FormSectionTitle from "./FormSectionTitle";

function isFixedSelected(interestRateType) {
  return !interestRateType || interestRateType === FIXED_RATE;
}

function isMarketExpectationsSelected(shockType) {
  return !shockType || shockType === MARKET_EXPECTATIONS_SHOCK;
}

function shouldDisableShockValue(curve, shockType) {
  return (
    curve !== CAP_VOLS &&
    shockType === MARKET_EXPECTATIONS_SHOCK
  );
}

function getShockValueLabel(shockType) {
  if (shockType === PARALLEL_SHOCK) {
    return "Parallel Shift Amt (bp)";
  }
  if (shockType === STANDARD_DEVIATION_SHOCK) {
    return "Standard Deviations";
  }

  return "";
}

const StyledDecimalInput = styled(DecimalInput)`& {
    width:100%;
  }`;

const StyledAutoCompleteInput = styled(AutoCompleteInput)`& {
    width:100%;
  }`;

const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
 }`;
const RateEnvironmentSection = ({ formik }) => {
  const { values } = formik;
  const shouldHideFloatingRate = false;
  const shouldHideShockValue = isMarketExpectationsSelected(values.shockType);

  return (
    <>
      <Grid item xs={12} hidden={shouldHideFloatingRate}>
        <FormSectionTitle title="Rate Environment" />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} hidden={shouldHideFloatingRate}>
        <StyledAutoCompleteInput
          label={<StyledLabel>{"Shock Scenario"}</StyledLabel>}
          fieldName="shockType"
          selectValue="value"
          options={shocks}
        />
      </Grid>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} hidden={shouldHideFloatingRate || shouldHideShockValue}>
        <StyledDecimalInput
          calculateLabel={({ values }) => getShockValueLabel(values.shockType)}
          fieldName="shockValue"
          disabled={shouldDisableShockValue(values.curve, values.shockType)}
        />
      </Grid>
    </>
  );
};
export default compose(
  connect
)(RateEnvironmentSection);
